import { Button } from '@/components/Button'
import { Header } from '@/components/Header'
import { useSignIn } from '@/hooks/useSignIn'

type LoginProps = {
  bodyText?: string
  titleSize?: string
}

export const Login = ({ bodyText, titleSize = 'text-3xl' }: LoginProps) => {
  const { signIn } = useSignIn()
  return (
    <>
      <Header title="Log in" />
      <div className="mx-auto max-w-2xl px-4 py-16 text-center sm:px-6 sm:py-20 lg:px-8">
        <h2 className={`${titleSize} font-bold tracking-tight text-black`}>
          <span className="block">Log in to continue</span>
        </h2>
        <p className="mt-4 text-lg leading-6 text-gray-600">
          {bodyText ??
            'In order to use this feature, you need to be logged into your account.'}
        </p>
        <Button
          style="primary"
          size="lg"
          classes="mt-8"
          onClick={() => signIn()}
        >
          Log in
        </Button>
      </div>
    </>
  )
}
